
import React, { Component, Suspense } from 'react';
import { HashRouter, BrowserRouter, Route, Link, Redirect, Switch } from 'react-router-dom';

import { isMobile } from 'react-device-detect';


import { goPage } from './historyConfig'


import Container from "./components/Container"



import LoginPage from './pages/Login'
import RegisterPage from './pages/Register'
import NoFoundPage from './pages/NoFound'

import ProfilePage from './pages/Profile'

import PolicyPage from './pages/Policy'


import Loading from './components/Loading';


import RecoveryPassword from './pages/RecoveryPassword'

import ReactChatWidget from './components/ReactChatWidget'

import { history } from "./historyConfig"

import "./App.css"

import SystemSettings from './pages/SystemSettings'
import HomePage from './pages/HourseBet'
import User from './pages/User';
import Program from './pages/Program'
import UserLimit from './pages/UserLimit'
import WebTv from './pages/WebTv'
import ResultPage from './pages/Result'

import Coupon from './pages/Coupon'
import CreateUser from './pages/CreateUser'
import CreditLimit from './pages/CreditLimit'

import ReportPage from './pages/Report'

import ReportDetail from './pages/ReportDetail'

import SearchPage from './pages/Search'
import Panel from './pages/Panel';


import _ from 'lodash'


import { inject, observer } from 'mobx-react';

//SOCKET
///export const socket = io(apiBaseUrl,{timeout:0})


/// !!!! SONRA MUTLAKA AKTİFLEŞTİR ###

if (process.env.NODE_ENV !== "development") {
  console.log = () => { };
}
else {
  console.log("DEV: ", process.env.NODE_ENV)
  // console.log = () => {};
}

//export default  React.createClass({
@inject('UserStore', 'SocketStore')
@observer
export default class App extends Component {


  componentDidMount() {

    const socket = this.props.socket

    this.props.SocketStore.setSocket(socket)

    //storeden kullanıcı datalarını getir
    const apiKey = this.props.UserStore.getCompanyCode
    const userId = this.props.UserStore.getUserId

    socket.emit('joinRoom', { username: userId, room: apiKey });

    socket.on("test-10sc", (arg) => {
      console.log("test-10sc", arg)
    })

    // online kullanıcılar online-users
    socket.on("online-users", (arg) => {
      console.log("online-users", arg)
      this.props.UserStore.setOnlineUsers(arg.users)
    })

    console.log("socket App", socket)
    console.log("componentDidMount App", { apiKey })


    //kullanıcıyı sistemden at
    socket.on("logout", (arg) => {
      console.log("socket.logout", arg)
      this.props.UserStore.logout();
      goPage("login")
    });



  }

  render() {
    return (
      <Suspense fallback={(<Loading />)}>
        <BrowserRouter
          // basename="/app" 
          history={history}>
          <Switch>
            <Route exact exact path="/"
              component={() => <Container
              //  headType="fixed"
              ><HomePage /></Container>}
            />
            <Route exact exact path="/webtv"
              component={() => <Container><WebTv /></Container>}
            />
            <Route exact exact path="/program"
              component={() => <Container
              ><Program /></Container>}
            />

            <Route exact exact path="/panel"
              component={() => <Container><Panel /></Container>}
            />
            <Route exact exact path="/panel/user"
              component={() => <Container><User /></Container>}
            />
            <Route exact exact path="/panel/user/create"
              component={() => <Container><CreateUser /></Container>}
            />

            <Route exact path="/panel/profile/"
              //component={ProfilePage} 
              component={() => <Container><ProfilePage /></Container>}
            />
            <Route exact exact path="/panel/report"
              component={() => <Container><ReportPage /></Container>}
            />
            <Route exact exact path="/panel/report-detail"
              component={() => <Container><ReportDetail /></Container>}
            />
            <Route exact exact path="/panel/user/limit"
              component={() => <Container><UserLimit /></Container>}
            />
            <Route exact exact path="/panel/user/credit"
              component={() => <Container><CreditLimit /></Container>}
            />

            <Route exact exact path="/panel/user/coupon"
              component={() => <Container><Coupon /></Container>}
            />
            <Route exact exact path="/panel/result"
              component={() => <Container><ResultPage /></Container>}
            />
            <Route exact exact path="/panel/system-settings"
              component={() => <Container><SystemSettings /></Container>}
            />

            <Route exact exact path="/search"
              component={() => <Container><SearchPage /></Container>}
            />

            <Route exact exact path="/create"
              component={() => <CreateOrder />}
            />

            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/register" component={RegisterPage} />
            <Route exact path="/recovery/:id" component={RecoveryPassword} />
            <Route exact path="/policy" component={PolicyPage} />

            <Route exact path="/user/:id" component={ProfilePage} />
            <Route path="/404" component={NoFoundPage} />

            <Redirect
              from='*'
              to='/404' />
          </Switch>
          {
            //<ReactChatWidget/>
          }
        </BrowserRouter>
      </Suspense>
    )
  }
}
